import HelmetCustom from '../components/Assets/HelmetCustom';
import Loader from '../components/Assets/Loader';

import Layout from '../layout/Layout';

import useAuth from '../features/auth/useAuth';
import RouteManager from '../router/RouteManager';
import styles from './app.module.scss';
import useInitApp from './hooks/useInitApp';

function App() {
  useAuth({ loadUser: true });
  useInitApp();

  return (
    <div className={styles.app}>
      <HelmetCustom />
      <Loader />
      <Layout>
        <RouteManager />
      </Layout>
    </div>
  );
}

export default App;
